import { createFileRoute } from "@tanstack/react-router";
import OmOss from "@/pages/OmOss";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/om-oss")({
  head: () =>
    buildSeoHead(publicPageSeo.omOss, [
      buildPageSchema(publicPageSeo.omOss, "AboutPage"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/om-oss") ?? []),
    ]),
  component: OmOss,
});
